<template>
  <div id="SalesPerson" class="order-type-select">
    <v-select
      label="id"
      ref="SalesPersonSelect"
      placeholder="Vendedor"
      :filterable="false"
      :options="options"
      @search="onSearch"
      @input="setSalesPerson"
      :value="this.$store.state.orderproperties.SalesPerson"
    >
      <template slot="no-options"> Vendedor... </template>
      <template slot="option" slot-scope="option">
        <div>
          {{ option.id }} -
          {{ option.name }}
        </div>
      </template>
      <template slot="selected-option" scope="option">
        <div>
          {{ option.id }} -
          {{ option.name }}
        </div>
      </template>
    </v-select>
    <b-alert
      v-if="
        this.$store.state.custShipToList.length > 0 &&
        !this.$store.state.orderproperties.ShipToCode
      "
      show
      variant="danger"
      >Seleccione Dirección de envío</b-alert
    >
    <b-alert
      v-if="
        this.$store.state.authContactList.length > 0 &&
        !this.$store.state.orderproperties.AuthContact
      "
      show
      variant="danger"
      >Seleccione Contacto Autorizado</b-alert
    >
    <b-btn block v-b-toggle.collapse1 variant="primary">Más campos...</b-btn>
    <b-collapse id="collapse1" class="mt-2">
      <b-form-input
        id="custName2"
        type="text"
        @change="onChange('custName2', $event)"
        :value="getValue('custName2')"
        :maxlength="50"
        placeholder="Nombre"
      >
      </b-form-input>
      <b-form-input
        id="custAddr"
        type="text"
        @change="onChange('custAddr', $event)"
        :value="getValue('custAddr')"
        :maxlength="50"
        placeholder="Dirección"
      >
      </b-form-input>
      <b-form-input
        id="custPostCode"
        type="text"
        @change="onChange('custPostCode', $event)"
        :value="getValue('custPostCode')"
        :maxlength="10"
        placeholder="Cod. Postal"
      >
      </b-form-input>
      <b-form-input
        id="custCity"
        type="text"
        @change="onChange('custCity', $event)"
        :value="getValue('custCity')"
        :maxlength="20"
        placeholder="Provincia"
      >
      </b-form-input>
      <b-form-input
        id="custVATNo"
        type="text"
        @change="onChange('custVATNo', $event)"
        :value="getValue('custVATNo')"
        :maxlength="20"
        placeholder="NIF"
      >
      </b-form-input>
      <b-form-input
        id="ExtDocNo"
        type="text"
        v-model="ExtDocNo"
        :maxlength="20"
        placeholder="Nº doc. externo"
      >
      </b-form-input>
      <b-link
        @click="GetAuthContact"
        v-bind:id="'AuthCont'"
        align-h="start"
        href="#"
        >Contacto Autorizado: {{ AuthContact }}</b-link
      >
      <b-btn variant="outline-primary" id="delbtn" @click="SetAuthContact('')"
        ><font-awesome-icon icon="backspace" :style="{ color: 'black' }"
      /></b-btn>
      <b-popover
        triggers="click blur"
        v-bind:target="'AuthCont'"
        :placement="'leftbottom'"
        title="Contacto Autorizado..."
      >
        <b-table
          @row-clicked="SetAuthContact($event)"
          striped
          hover
          :items="AuthContactList"
        ></b-table>
      </b-popover>
      <br />
      <b-link
        @click="GetShipToCode"
        v-bind:id="'ShipTo'"
        align-h="start"
        href="#"
        >Enviar a: {{ ShipToCode }}</b-link
      >
      <b-btn variant="outline-primary" id="delbtn" @click="SetShipToCode('')"
        ><font-awesome-icon icon="backspace" :style="{ color: 'black' }"
      /></b-btn>
      <b-popover
        triggers="click blur"
        v-bind:target="'ShipTo'"
        :placement="'leftbottom'"
        title="Enviar a..."
      >
        <b-table
          @row-clicked="SetShipToCode($event)"
          striped
          hover
          :items="ShipToList"
        ></b-table>
      </b-popover>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "SalesHeader",
  data() {
    return {
      options: [],
      ShipToList: [],
      AuthContactList: [],
    };
  },
  methods: {
    setSalesPerson(val) {
      this.$store.commit("setSalesPerson", val);
    },
    onSearch(search, loading) {
      loading(true);
      this.axios
        .post(
          this.ApiBaseUrl + "CustSearch/SalesPersonList",
          JSON.stringify(search),
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          this.options = response.data;
          loading(false);
        });
    },
    GetShipToCode() {
      this.axios
        .post(
          this.ApiBaseUrl + "CustSearch/GetCustShipTo",
          JSON.stringify(this.$store.state.customer.id),
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          if (response.data.length > 0) this.ShipToList = response.data;
        });
    },
    SetShipToCode(item) {
      this.$store.commit("SetShipToCode", item.code);
    },
    GetAuthContact() {
      this.axios
        .get(this.ApiBaseUrl + "Contact/" + this.$store.state.customer.id, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          if (response.data.length > 0) {
            this.AuthContactList = response.data;
          }
        });
    },
    SetAuthContact(item) {
      this.$store.commit("SetAuthContact", item.id);
    },
    onChange(prop, value) {
      this.$store.commit("updateProp", { prop: prop, value: value });
    },
    getValue(prop) {
      return this.$store.state.orderproperties[prop];
    },
  },
  /*
    created: function () {
        this.axios.post(this.ApiBaseUrl + 'CustSearch/SalesPersonList','',{headers: {"Content-Type": "application/json"}})
            .then((response) => {        
                this.options = response.data;                               
            })
    },*/
  computed: {
    ExtDocNo: {
      get() {
        return this.$store.state.orderproperties.ExtDocNo;
      },
      set(value) {
        this.$store.commit("SetExtDocNo", value);
      },
    },
    ShipToCode: {
      get() {
        return this.$store.state.orderproperties.ShipToCode;
      },
      set(value) {
        this.$store.commit("SetShipToCode", value);
      },
    },
    AuthContact: {
      get() {
        return this.$store.state.orderproperties.AuthContact;
      },
      set(value) {
        this.$store.commit("SetAuthContact", value);
      },
    }
  },
};
</script>